import type { JsonQuestionnaireSection } from '@/components/questionnaires/json-driven/types';

type TriggeredQuestionnaireLike = {
  section: JsonQuestionnaireSection;
  meta: { questionnaireId: string };
};

export function normalizeQuestionnaireId(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
}

export function getSectionQuestionnaireIds(
  section: JsonQuestionnaireSection | null | undefined
): Set<string> {
  const ids = new Set<string>();
  if (!section) return ids;

  const record = section as JsonQuestionnaireSection & { _id?: string };
  [
    record._id,
    section.id,
    section.questionnaireId,
    section.originalQuestionnaireId,
  ].forEach((value) => {
    const id = normalizeQuestionnaireId(value);
    if (id) ids.add(id);
  });

  return ids;
}

/** Pre-consultation screening collects initial answers without opening follow-up modules. */
export function isPreConsultationScreening(
  section: JsonQuestionnaireSection | null | undefined
): boolean {
  const ids = getSectionQuestionnaireIds(section);
  return ids.has('pre-consultation-screening') || ids.has('696f888e02616daa6cbaea81');
}

export function getTriggeredBlockQuestionnaireIds(block: TriggeredQuestionnaireLike): Set<string> {
  const ids = getSectionQuestionnaireIds(block.section);
  const metaId = normalizeQuestionnaireId(block.meta.questionnaireId);
  if (metaId) ids.add(metaId);
  return ids;
}

export function setsIntersect(left: Set<string>, right: Set<string>): boolean {
  for (const value of left) {
    if (right.has(value)) return true;
  }
  return false;
}

export function addQuestionnaireIds(target: Set<string>, source: Iterable<string>): void {
  for (const id of source) {
    target.add(id);
  }
}
